import { useEffect, useMemo, useState } from 'react';
import { sha256Hash } from '@/lib/encryptHelper';
import useAppointmentStore from '@/store/AppointmentStore';
import useSessionStore from '@/store/SessionStore';

export default function useContactHashes() {
  const contactInfo = useAppointmentStore((state) => state.contactInfo);
  const flowType = useSessionStore((state) => state.flowType);
  const sessionSource = useSessionStore((state) => state.sessionSource);

  const [emailHash, setEmailHash] = useState('');
  const [phoneHash, setPhoneHash] = useState('');

  useEffect(() => {
    let cancelled = false;

    const emailNorm = (contactInfo?.email ?? '').trim().toLowerCase();
    const phoneNorm = contactInfo?.phoneNumber ?? '';

    (async () => {
      const [eHash, pHash] = await Promise.all([
        emailNorm ? sha256Hash(emailNorm) : Promise.resolve(''),
        phoneNorm ? sha256Hash(phoneNorm) : Promise.resolve(''),
      ]);
      if (!cancelled) {
        setEmailHash(eHash);
        setPhoneHash(pHash);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [contactInfo?.email, contactInfo?.phoneNumber]);

  const contactInfoTaggingReady = useMemo(() => {
    const pref = contactInfo?.communicationPreference;
    const usersReschedulingViaEmailLink = sessionSource === 'email';
    if (usersReschedulingViaEmailLink) {
      return true;
    }
    if (flowType === 'emailInquiry') {
      if (pref === 'Email') return !!emailHash;
      if (pref === 'Phone') return !!phoneHash;
      return true;
    }

    return !!emailHash && !!phoneHash;
  }, [
    flowType,
    contactInfo?.communicationPreference,
    emailHash,
    phoneHash,
    sessionSource,
  ]);

  return { emailHash, phoneHash, contactInfoTaggingReady };
}
